import { AgTechQueryBuilder } from '@agtech/core/data/queries/AgTechDataQueries';
import { AgTechButtonProps, AgTechButton, AgTechClickEventHandler } from '@agtech/web/components/Buttons/AgTechButtons';
import { AgTechFormNumberControl } from '@agtech/web/components/Forms/Controls/AgTechFormNumberControl';
import { AgTechFormTextControl } from '@agtech/web/components/Forms/Controls/AgTechFormTextControl';
import { AgTechFormToggleControl } from '@agtech/web/components/Forms/Controls/AgTechFormToggleControl';
import AgTechFormBody from '@agtech/web/components/Forms/Layout/AgTechFormBody';
import { AgTechFormRow } from '@agtech/web/components/Forms/Layout/AgTechFormRow';
import AgTechFormDialog from '@agtech/web/components/Portals/Dialogs/AgTechFormDialog';
import { SaleDiscount, DefaultSaleDiscount } from '@sales/data/sales/discounts/SaleDiscountData';
import { useSaleDiscountDataWriteDiscountAction } from '@sales/data/sales/discounts/SaleDiscountDataActions';
import React from 'react'

export type SaleDiscountDialogProps = {
    discount?: SaleDiscount
}

const SaleDiscountDialog = (props: SaleDiscountDialogProps) => {
    const writeDiscountAction = useSaleDiscountDataWriteDiscountAction();

    return (
        <AgTechFormDialog
            width={450}
            structure={() => ({
                header: props.discount ? 'Update Discount - ' + props.discount.name : 'Create Discount',
                submitButtonText: props.discount ? 'Update' : 'Create',
            })}
            dialogData={{
                query: AgTechQueryBuilder.buildQueryResult({
                    data: props.discount ?? DefaultSaleDiscount
                }),
                getDialogData: d => d
            }}
            dialogAction={{
                action: writeDiscountAction,
                getActionData: d => ({
                    discount: d
                })
            }}
        >
            {(formContext) => (
                <AgTechFormBody>
                    <AgTechFormRow>
                        <AgTechFormTextControl
                            entityType={formContext.entity}
                            caption="Name"
                            required={true}
                            focused={true}
                            value={entity => entity.name}
                            width={99}
                            onControlValueChanged={async (e, val) => ({
                                ...e,
                                name: val
                            })}
                        />
                    </AgTechFormRow>
                    <AgTechFormRow>
                        <AgTechFormNumberControl
                            entityType={formContext.entity}
                            caption="Amount"
                            required={true}
                            value={entity => entity.amount}
                            onControlValueChanged={async (e, val) => ({
                                ...e,
                                amount: val
                            })}
                            validation={{
                                validateOnSubmit: (ent, val) => {
                                    let discountAmountValidationMessage = '';

                                    if (ent.isPercentage && val > 100) {
                                        discountAmountValidationMessage = "A percentage discount cannot exceed 100%";
                                    }
            
                                    return discountAmountValidationMessage;
                                }
                            }}
                        />
                        <AgTechFormToggleControl
                            entityType={formContext.entity}
                            caption="Is Percentage?"
                            value={entity => entity.isPercentage ?? false}
                            onControlValueChanged={async (e, val) => ({
                                ...e,
                                isPercentage: val
                            })}
                        />
                    </AgTechFormRow>
                </AgTechFormBody>
            )}
        </AgTechFormDialog>
    )
}

SaleDiscountDialog.Open = (e: AgTechClickEventHandler, props: SaleDiscountDialogProps) => {
    e.dialogs.openDialog({
        dialog: () => <SaleDiscountDialog discount={props.discount} />
    });
}

SaleDiscountDialog.Button = (props: SaleDiscountDialogProps & AgTechButtonProps) => {
    return (
        <AgTechButton
            text={props.discount ? 'Update discount' : 'Create discount'}
            icon={props.discount ? 'fas fa-edit' : 'fas fa-plus'}
            {...props}
            action={e => SaleDiscountDialog.Open(e, props)}
        />
    )
}

export default SaleDiscountDialog